import { render } from "./MapComponent.vue?vue&type=template&id=5845d0d0&scoped=true"
import script from "./MapComponent.vue?vue&type=script&lang=js"
export * from "./MapComponent.vue?vue&type=script&lang=js"

import "./MapComponent.vue?vue&type=style&index=0&id=5845d0d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845d0d0"]])

export default __exports__